<script>
export default {
  name: 'SectionTitle',
  components: {},
  props: {
    label: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <span class="text-xs leading-4 font-normal text-dark-6 my-4">
    {{ $t(`SIDEBAR.${label}`) }}
  </span>
</template>
